import request from '@/utils/request'

export function getRelations(size, page, find) {
  return request({
    url: `/general/relations`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find
    }
  })
}

export function getRelationById(id) {
  return request({
    url: `/general/relations/id/${id}`,
    method: 'get'
  })
}

export function createRelations(data) {
  return request({
    url: `/general/relations/create`,
    method: 'post',
    data
  })
}

export function updateRelations(id, data) {
  return request({
    url: `/general/relations/id/${id}`,
    method: 'put',
    data
  })
}

export function removeRelations(id) {
  return request({
    url: `/general/relations/id/${id}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/relation.js